import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { AuthContextProvider } from './context/AuthContext';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import darkTheme from './theme';

const ApplicationTransport = () => {
  return (
    <main>
      <React.StrictMode>
        <AuthContextProvider>
          <ThemeProvider theme={darkTheme}>
            <CssBaseline />
            <App />
          </ThemeProvider>
        </AuthContextProvider>
      </React.StrictMode>
    </main>
  );
};

ReactDOM.render(<ApplicationTransport />, document.getElementById('root'));
